module.exports = __webpack_public_path__ + "static/8-1f659a9394bed93352f3a36da329b538.jpeg";